<div class="event-purchase-wrapper" *ngIf="!hideContent"
     [ngClass]="{'customer-window': routeService.isWindow, 'with-footer': utilService.isMobile,
                 'with-extended-footer': cartService.currentBooking?.number}">
  <div class="flex flex-column">
    <div *ngIf="!routeService.isWindow">
      <div class="heading-2 break-word two-line-overflow no-margin">{{ event.title | translateValue }}</div>
      <app-event-info-props *ngIf="eventProps" [eventProps]="eventProps"></app-event-info-props>
      <div class="flex flex-flat space-between top-spacer">
        <div class="flex flex-middle" [ngClass]="{'flex-column': utilService.isMobile}">
          <div class="flex flex-wrap">
            <span class="badge" [class]="getStatusBadgeClass">{{ event.status?.name | translate }}</span>
            <span class="badge {{ getStateBadgeClass(state) }}" *ngFor="let state of event.assignedStates">
              {{ ('general.api_events_event_state_' + state) | translate }}</span>
            <span class="badge left-spacer" *ngIf="isPartOfSeason">{{ 'general.api_event_is_part_of_season' | translate }}</span>
          </div>
          <div class="flex desktop">
            <a class="link" (click)="openEventDetails()">
              <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
              <span>{{ 'general.api_event_info' | translate }}</span>
            </a>
            <a class="link" *ngIf="!event.boEvent" (click)="openEventBookings()">
              <mat-icon class="svg-icon" [svgIcon]="'bookings'"></mat-icon>
              <span>{{ 'general.api_general_event_bookings' | translate }}</span>
            </a>
            <a class="link" *ngIf="!isPreparation && authService.hasReportingPromoterMyEventsPrivilege && isOwnerCenter" (click)="openReportOverview()">
              <mat-icon class="svg-icon" [svgIcon]="'bar_graph'"></mat-icon>
              <span>{{ 'general.api_reports_report_overview' | translate }}</span>
            </a>
          </div>
        </div>
        <div class="flex flex-end decreased-margin mobile">
          <button mat-button class="input-button icon-button" (click)="openEventDetails()">
            <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
          </button>
          <button mat-button class="input-button icon-button" *ngIf="!event.boEvent" (click)="openEventBookings()">
            <mat-icon class="svg-icon" [svgIcon]="'bookings'"></mat-icon>
          </button>
          <button mat-button class="input-button icon-button" *ngIf="!isPreparation && authService.hasReportingPromoterMyEventsPrivilege && isOwnerCenter" (click)="openReportOverview()">
            <mat-icon class="svg-icon" [svgIcon]="'bar_graph'"></mat-icon>
          </button>
          <button mat-button class="input-button icon-button" *ngIf="isRefundVisible" [matMenuTriggerFor]="refundMenu">
            <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
          </button>
        </div>
        <div class="flex flex-wrap flex-end desktop" *ngIf="isRefundVisible">
          <a class="link" *ngIf="authService.hasRefundExchangePrivilege" (click)="openTicketRangeInput(true)">
            <mat-icon class="svg-icon" [svgIcon]="'transaction'"></mat-icon>
            <span>{{ 'general.api_cart_start_refund_exchange' | translate }}</span>
          </a>
          <a class="link" *ngIf="canRefundFromVenueMap" [matMenuTriggerFor]="refundMenu">
            <mat-icon class="svg-icon" [svgIcon]="'refresh'"></mat-icon>
            <span>{{ 'general.api_cart_start_refund' | translate }}</span>
            <mat-icon class="svg-icon icon-dropdown" [svgIcon]="'arrow_down'"></mat-icon>
          </a>
          <a class="link" *ngIf="!canRefundFromVenueMap" (click)="openTicketRangeInput()">
            <mat-icon class="svg-icon" [svgIcon]="'ticket_change'"></mat-icon>
            <span>{{ 'general.api_cart_refund_tickets_by_id' | translate }}</span>
          </a>
        </div>
      </div>
      <mat-menu #refundMenu="matMenu" [xPosition]="'before'">
        <button mat-menu-item class="mobile" *ngIf="authService.hasRefundExchangePrivilege" (click)="openTicketRangeInput(true)">
          <mat-icon class="svg-icon" [svgIcon]="'transaction'"></mat-icon>
          <span>{{ 'general.api_cart_start_refund_exchange' | translate }}</span>
        </button>
        <button mat-menu-item (click)="openTicketRangeInput()">
          <mat-icon class="svg-icon" [svgIcon]="'ticket_change'"></mat-icon>
          <span>{{ 'general.api_cart_refund_tickets_by_id' | translate }}</span>
        </button>
        <button class="desktop" mat-menu-item *ngIf="canRefundFromVenueMap" (click)="refundModeStart()">
          <mat-icon class="svg-icon" [svgIcon]="'refresh'"></mat-icon>
          <span>{{ 'general.api_venue_map_refund_mode_enter' | translate }}</span>
        </button>
      </mat-menu>
    </div>
    <ng-container *ngIf="event?.eventId">
      <app-ticket-select *ngIf="event?.eventId && hasCorrectEventType"
                         [event]="event"
                         [refundVisible]="isRefundVisible" [(refundMode)]="refundMode"
                         [(hideContent)]="hideContent"
                         [(selectedSeatIds)]="selectedSeatIds"
                         [(deselectedSeatIds)]="deselectedSeatIds"
                         (selectedSectorChange)="selectedSector = $event"
                         (eventSectorsChange)="eventSectors = $event"
                         (removeSeats)="removeSeats($event)"
                         (updateSeats)="updateSeats()"
                         (updateEventDetails)="initEventDetails()"></app-ticket-select>
      <div class="body-2 text-muted top-spacer" *ngIf="!hasCorrectEventType">
        <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
        {{ (event.boEvent ? 'general.api_cart_legacy_event_tickets_in_cart' : 'general.api_cart_bo_event_tickets_in_cart') | translate }}
      </div>
    </ng-container>
  </div>
  <div class="desktop" *ngIf="!routeService.isWindow">
    <mat-card appearance="outlined" class="selected-tickets no-margin" *ngIf="!routeService.isWindow">
      <app-selected-tickets [eventId]="event?.eventId"
                            [eventSectors]="eventSectors"
                            [selectedTicketTypes]="cartService.selectedTicketsMap?.selectedTicketTypes"
                            (isLoading)="$event ? startLoader() : stopLoader()"
                            (removeSeats)="removeSeats($event)"></app-selected-tickets>
    </mat-card>
  </div>
</div>
<footer class="mobile selected-tickets-footer" *ngIf="cartService.showSelectedTickets">
  <app-selected-tickets [eventId]="event?.eventId"
                        [eventSectors]="eventSectors"
                        (isLoading)="$event ? startLoader() : stopLoader()"
                        (removeSeats)="removeSeats($event)"></app-selected-tickets>
</footer>
<app-footer *ngIf="!routeService.isWindow" [leftContent]="cartService.currentBooking?.number ? bookingFooter : null">
  <ng-template #bookingFooter>
    <app-booking-footer class="mobile-max-width"></app-booking-footer>
  </ng-template>
  <div class="flex flex-end flex-column-mobile mobile-max-width">
    <div class="flex space-between white-space-no-wrap" *ngIf="cartService.selectedTicketsTotal">
      <div>
        <span class="text-muted">{{ 'general.api_cart_table_items_total' | translate }}</span>
        <br>
        <span class="heading-5 text-base bold no-margin">{{ cartService.selectedTicketsTotal.ticketQuantity | quantityInPcs }}</span>
      </div>
      <div class="align-right flex">
        <div>
          <span class="text-muted">{{ 'general.api_cart_table_total' | translate }}</span>
          <br>
          <span class="heading-5 text-base bold no-margin">{{ cartService.selectedTicketsTotal.ticketQuantity ? (cartService.selectedTicketsTotal.total | price) : '-' }}</span>
        </div>
        <div class="mobile">
          <button mat-button class="input-button icon-button" (click)="cartService.toggleSelectedTickets()"
                  [disabled]="!cartService.selectedTicketsTotal.ticketQuantity">
            <mat-icon class="svg-icon" [svgIcon]="cartService.showSelectedTickets ? 'arrow_down' : 'arrow_up'"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <button mat-flat-button color="primary" *ngIf="!cartService.currentBooking?.number" [disabled]="!cartService.ticketCount && !cartService.hasSelfServicePromocode(event.eventId)"
            [routerLink]="['/app/sales-terminal/cart']">
      {{ 'general.api_cart_view' | translate }}
    </button>
    <button mat-flat-button color="primary" *ngIf="cartService.currentBooking?.number" [disabled]="!cartService.ticketCount"
            (click)="addTicketsToBooking(cartService.currentBooking.id)">
      {{ 'general.api_add_to_booking' | translate }}
    </button>
  </div>
</app-footer>
<div class="window-empty" *ngIf="hideContent && purchaseSucceed">
  <div class="heading-4">{{ 'general.api_cart_purchase_succeed' | translate }}</div>
</div>
<div *ngIf="hideContent && cartService.cart.events?.length">
  <div class="flex customer-checkout">
    <mat-card appearance="outlined" class="card-no-responsiveness">
      <app-cart-table *ngIf="!isLoading"
                      [service]="cartService"
                      [canSelect]="false"
                      [canEdit]="false"
                      [collapsible]="false"
      ></app-cart-table>
    </mat-card>
    <app-cart-totals [cartService]="cartService"></app-cart-totals>
  </div>
</div>
